/* MyLilan Detroland draft product landing interactions, v2. All discounts require a real code. */
(function () {
  'use strict';
  function setup() {
    const page = document.getElementById('ml-dl-page');
    if (!page || page.dataset.mlInitialized === 'yes') return;
    page.dataset.mlInitialized = 'yes';
    const one = (selector,root=page) => root.querySelector(selector);
    const many = (selector,root=page) => Array.from(root.querySelectorAll(selector));
    const status = one('[data-ml-status]');
    const menu = one('[data-ml-menu]');
    const menuToggle = one('[data-ml-menu-toggle]');
    if (menu && menuToggle) {
      menuToggle.addEventListener('click', function () {
        const isOpen = menu.classList.toggle('is-open');
        menuToggle.setAttribute('aria-expanded', String(isOpen));
      });
      many('a',menu).forEach(function(a){
        a.addEventListener('click',function(){menu.classList.remove('is-open');menuToggle.setAttribute('aria-expanded','false');});
      });
    }

    /* Automatic before/after sweep. Any user touch, drag, key, arrow or dot click stops it. */
    many('[data-ml-comparison]').forEach(function(carousel) {
      const slides=many('[data-ml-slide]',carousel), dots=many('[data-ml-dot]',carousel);
      if(!slides.length)return;
      let index=Math.max(0,slides.findIndex(slide=>slide.classList.contains('is-active')));
      let manuallyStopped=false, visible=false, frame=null, holdTimer=null, startTime=null;
      const reduced=!!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      function renderPosition(slide,value) {
        const slider=one('.ml-dl-compare-range',slide);
        const images=one('.ml-dl-compare-images',slide);
        if(!slider||!images)return;
        const percent=Math.max(0,Math.min(100,value));
        slider.value=String(percent);
        images.style.setProperty('--pos',percent.toFixed(2)+'%');
      }
      function pause() {
        if(frame!==null){window.cancelAnimationFrame(frame);frame=null;}
        if(holdTimer!==null){window.clearTimeout(holdTimer);holdTimer=null;}
        startTime=null;
      }
      function userInteracted(){manuallyStopped=true;pause();}
      function animate(now) {
        frame=null;
        if(manuallyStopped||reduced||!visible||document.hidden)return;
        if(startTime===null)startTime=now;
        // Smooth motion: 50 -> 82 -> 18 -> 50, repeated every 5.2 seconds.
        const position=50+32*Math.sin((now-startTime)*2*Math.PI/5200);
        renderPosition(slides[index],position);
        frame=window.requestAnimationFrame(animate);
      }
      function autoPlay() {
        if(manuallyStopped||reduced||!visible||document.hidden||frame!==null||holdTimer!==null)return;
        startTime=null;
        holdTimer=window.setTimeout(function(){
          holdTimer=null;
          if(!manuallyStopped&&visible&&!document.hidden)frame=window.requestAnimationFrame(animate);
        },380);
      }
      function showSlide(nextIndex,byUser) {
        if(byUser)userInteracted();
        else pause();
        index=(nextIndex+slides.length)%slides.length;
        slides.forEach(function(slide,i){
          const active=i===index;
          slide.classList.toggle('is-active',active);
          slide.setAttribute('aria-hidden',String(!active));
          renderPosition(slide,50);
        });
        dots.forEach(function(dot,i){
          dot.classList.toggle('is-active',i===index);
          dot.setAttribute('aria-pressed',String(i===index));
        });
        autoPlay();
      }
      const prev=one('[data-ml-prev]',carousel), next=one('[data-ml-next]',carousel);
      if(prev)prev.addEventListener('click',function(){showSlide(index-1,true);});
      if(next)next.addEventListener('click',function(){showSlide(index+1,true);});
      dots.forEach(function(dot,i){dot.addEventListener('click',function(){showSlide(i,true);});});
      slides.forEach(function(slide){
        const slider=one('.ml-dl-compare-range',slide), images=one('.ml-dl-compare-images',slide);
        if(!slider||!images)return;
        slider.addEventListener('pointerdown',userInteracted,{passive:true});
        slider.addEventListener('touchstart',userInteracted,{passive:true});
        slider.addEventListener('mousedown',userInteracted);
        slider.addEventListener('keydown',userInteracted);
        slider.addEventListener('input',function(){
          userInteracted();
          renderPosition(slide,Number(slider.value));
        },{passive:true});
      });
      if('IntersectionObserver' in window) {
        const observer=new IntersectionObserver(function(entries) {
          visible=entries.some(e=>e.isIntersecting);
          if(visible)autoPlay();else pause();
        },{threshold:0.15});
        observer.observe(carousel);
      }else{visible=true;}
      document.addEventListener('visibilitychange',function(){
        if(document.hidden)pause();else autoPlay();
      });
      showSlide(index,false);
    });

    /* On entry, show a genuine 15-minute session timer. The bar represents time remaining,
       not inventory. A merchant-configured actual promo deadline, when provided, takes precedence. */
    many('[data-ml-duration-seconds]').forEach(function(clock) {
      const duration=900; // 15 minutes; do not simulate inventory depletion.
      const pageId=page.getAttribute('data-product-id')||'product';
      const storageKey='mylilan:landing:15min:ends:'+pageId;
      let end=Date.parse(clock.getAttribute('data-ml-deadline')||'');
      const hasActualDeadline=Number.isFinite(end)&&end>0;
      if(!hasActualDeadline) {
        // One countdown per tab session; refreshing does not restart it.
        let saved=null;
        try { saved=window.sessionStorage.getItem(storageKey); } catch (_) {}
        const parsed=saved===null?NaN:Number(saved);
        if(Number.isFinite(parsed)&&parsed>0)end=parsed;
        else {
          end=Date.now()+duration*1000;
          try { window.sessionStorage.setItem(storageKey,String(end)); } catch (_) {}
        }
      }
      const progress=one('[data-ml-time-progress]');
      const progressFill=one('[data-ml-progress-fill]');
      const hours=one('[data-ml-timer-hours]',clock);
      const minutes=one('[data-ml-timer-minutes]',clock);
      const seconds=one('[data-ml-timer-seconds]',clock);
      const startSeconds=hasActualDeadline
        ?Math.max(1,Math.ceil((end-Date.now())/1000))
        :duration;
      function renderClock() {
        const left=Math.max(0,Math.ceil((end-Date.now())/1000));
        if(hours)hours.textContent=String(Math.floor(left/3600)).padStart(2,'0');
        if(minutes)minutes.textContent=String(Math.floor((left%3600)/60)).padStart(2,'0');
        if(seconds)seconds.textContent=String(left%60).padStart(2,'0');
        if(progress) {
          progress.setAttribute('aria-valuemax',String(startSeconds));
          progress.setAttribute('aria-valuenow',String(Math.min(left,startSeconds)));
        }
        if(progressFill) {
          const pct=Math.max(0,Math.min(100,(left/startSeconds)*100));
          progressFill.style.width=pct.toFixed(2)+'%';
        }
        clock.setAttribute('aria-label',left===0?'Countdown beendet':'Verbleibende Zeit '+Math.floor(left/60)+' Minuten '+left%60+' Sekunden');
        return left;
      }
      renderClock();
      const handle=window.setInterval(function(){
        if(renderClock()<=0)window.clearInterval(handle);
      },1000);
      document.addEventListener('visibilitychange',function(){
        if(!document.hidden)renderClock();
      });
    });

    /* Product data comes exclusively from Shopify's current product and variants. */
    const variants=many('[data-ml-variant]');
    const bundleRadios=many('input[name="ml-dl-bundle"]');
    const bundleContainer=one('.ml-dl-bundle-area');
    const tierSelectors=many('select[data-ml-bundle-variant]');
    const notice=one('[data-ml-promo-notice]');
    const cartButton=one('[data-ml-add-cart]');
    const checkoutButton=one('[data-ml-checkout]');
    const actionButtons=[cartButton,checkoutButton].filter(Boolean);
    const currency=page.getAttribute('data-currency')||'EUR';
    const locale='de-DE';
    const formatter=new Intl.NumberFormat(locale,{style:'currency',currency:currency});
    if(!variants.length||!bundleRadios.length)return;
    let chosenVariant=variants.find(b=>b.classList.contains('is-active'))||variants.find(b=>!b.disabled)||variants[0];
    let chosenTier=Number((bundleRadios.find(r=>r.checked)||bundleRadios[0]).value);
    function money(cents){return formatter.format(Number(cents||0)/100);}
    function getPrice(source){return Number(source && (source.getAttribute('data-ml-price')||(source.dataset&&source.dataset.mlPrice)))||0;}
    function variantPrice(id){
      const b=variants.find(v=>v.dataset.mlVariant===String(id));
      return getPrice(b);
    }
    function selectOf(tier,slot){
      return tierSelectors.find(s=>Number(s.dataset.mlBundleTier)===tier&&Number(s.dataset.mlBundleSlot)===slot);
    }
    function selectedIds(tier){
      if(tier===1)return [String(chosenVariant.dataset.mlVariant)];
      const ids=[];
      for(let slot=1;slot<=tier;slot++){
        const select=selectOf(tier,slot);
        if(!select) return [];
        ids.push(String(select.value));
      }
      return ids;
    }
    function basePrice(tier){
      return selectedIds(tier).reduce((sum,id)=>sum+variantPrice(id),0);
    }
    function discountCents(tier){return tier===2?318:tier===3?597:0;}
    function promoCode(tier) {
      if(tier===2)return (bundleContainer?.dataset.mlCodeTwo||'').trim();
      if(tier===3)return (bundleContainer?.dataset.mlCodeThree||'').trim();
      return '';
    }
    function setStatus(message){
      if(status){status.textContent=message||''; status.style.display=message?'block':'none';}
    }
    function syncActive(){
      many('[data-ml-bundle-card]').forEach(card=>{
        const active=Number(card.dataset.mlBundleCard)===chosenTier;
        card.classList.toggle('is-active',active);
        const r=one('input[name="ml-dl-bundle"]',card);
        if(r)r.checked=active;
      });
      const singleCents=getPrice(chosenVariant);
      const current=one('[data-ml-current-price]');
      if(current)current.textContent=money(singleCents);
      many('[data-ml-tier-price]').forEach(node=>{
        const tier=Number(node.dataset.mlTierPrice);
        node.textContent=money(basePrice(tier)-discountCents(tier));
      });
      many('[data-ml-tier-original]').forEach(node=>{
        const tier=Number(node.dataset.mlTierOriginal);
        node.textContent=money(basePrice(tier));
      });
      const sticky=one('[data-ml-sticky-price]');
      if(sticky)sticky.textContent=money(basePrice(chosenTier)-discountCents(chosenTier));
      if(notice){
        const unmet=chosenTier>1 && !promoCode(chosenTier);
        notice.hidden=!unmet;
        notice.textContent=unmet?'Designvorschau: Dieser Mengenrabatt ist noch nicht im Shopify-Checkout eingerichtet. Bitte vor Veröffentlichung einen echten Rabattcode konfigurieren.':'';
      }
      if(status&&status.textContent)setStatus('');
    }
    variants.forEach(button=>{
      button.addEventListener('click',function(){
        if(button.disabled)return;
        chosenVariant=button;
        variants.forEach(v=>{
          const active=v===button;
          v.classList.toggle('is-active',active);
          v.setAttribute('aria-pressed',String(active));
        });
        tierSelectors.forEach(s=>{
          if(Number(s.dataset.mlBundleSlot)===1) {
            const option=Array.from(s.options).find(o=>o.value===button.dataset.mlVariant&&!o.disabled);
            if(option)s.value=option.value;
          }
        });
        syncActive();
      });
    });
    bundleRadios.forEach(r=>{
      r.addEventListener('change',function(){
        chosenTier=Number(r.value);
        syncActive();
      });
    });
    tierSelectors.forEach(select=>{
      select.addEventListener('change',function(){
        const tier=Number(select.dataset.mlBundleTier);
        const slot=Number(select.dataset.mlBundleSlot);
        if(slot===1&&tier===chosenTier){
          const selected=variants.find(v=>v.dataset.mlVariant===select.value);
          if(selected&&!selected.disabled){
            chosenVariant=selected;
            variants.forEach(v=>{
              const active=v===selected;
              v.classList.toggle('is-active',active);
              v.setAttribute('aria-pressed',String(active));
            });
            tierSelectors.forEach(s=>{
              if(s!==select&&Number(s.dataset.mlBundleSlot)===1){
                const option=Array.from(s.options).find(o=>o.value===selected.dataset.mlVariant&&!o.disabled);
                if(option)s.value=option.value;
              }
            });
          }
        }
        syncActive();
      });
    });
    syncActive();

    function cartRoot(){
      const root=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/';
      return root.replace(/\/?$/,'/');
    }
    function lineItems(){
      const map=new Map();
      selectedIds(chosenTier).forEach(id=>{
        const parsed=Number(id);
        if(Number.isSafeInteger(parsed))map.set(parsed,(map.get(parsed)||0)+1);
      });
      return Array.from(map,([id,quantity])=>({id,quantity}));
    }
    function canProceed(){
      if(chosenTier>1&&!promoCode(chosenTier)){
        setStatus('Die Auswahl ist derzeit eine Designvorschau. Das Paket kann erst bestellt werden, wenn der entsprechende Shopify-Rabatt aktiv ist. Einzelkauf ist bereits möglich.');
        return false;
      }
      if(lineItems().length===0){
        setStatus('Bitte wählen Sie eine verfügbare Dioptrie aus.');
        return false;
      }
      return true;
    }
    async function addToCart(checkout){
      setStatus('');
      if(!canProceed())return;
      actionButtons.forEach(b=>{b.disabled=true;b.setAttribute('aria-busy','true');});
      try{
        const response=await fetch(cartRoot()+'cart/add.js',{
          method:'POST',credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:lineItems()})
        });
        if(!response.ok){
          let message='Der Artikel konnte nicht hinzugefügt werden.';
          try{const err=await response.json();message=err.description||err.message||message;}catch(_){}
          throw new Error(message);
        }
        const discountCode=promoCode(chosenTier);
        const redirectTo=cartRoot()+(checkout?'checkout':'cart');
        if(discountCode) {
          window.location.assign(cartRoot()+'discount/'+encodeURIComponent(discountCode)+'?redirect='+encodeURIComponent(redirectTo));
        }else{
          window.location.assign(redirectTo);
        }
      }catch(error){
        setStatus(error.message||'Bitte versuchen Sie es später erneut.');
        actionButtons.forEach(b=>{b.disabled=false;b.removeAttribute('aria-busy');});
      }
    }
    if(cartButton)cartButton.addEventListener('click',()=>addToCart(false));
    if(checkoutButton)checkoutButton.addEventListener('click',()=>addToCart(true));
    const sticky=one('[data-ml-sticky-buy]');
    const offer=one('#ml-dl-offer');
    if(sticky&&offer){
      function updateSticky(){
        const b=offer.getBoundingClientRect();
        sticky.classList.toggle('is-visible',window.scrollY>500&&b.top>window.innerHeight);
      }
      window.addEventListener('scroll',updateSticky,{passive:true});
      updateSticky();
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);
  else setup();
  document.addEventListener('shopify:section:load',setup);
})();
